// extracted by mini-css-extract-plugin
export default {"root":"CLTGTjHAoUeGK9kLKfO_","img":"xfSZ_QwfNApxIt8BUAFw","redirecting":"dl7ofFLQcDqCKbDX54ni"};